import ClosingHourModal from "./ClosingHourModal";
export default ClosingHourModal;